import { useEffect, useRef } from 'react';

import styles from './EndRoll.module.scss';

export const EndRoll = () => {
  const rollTextRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const rollText = rollTextRef.current;
    if (!rollText) return;
    rollText.style.setProperty('bottom', `${rollText.offsetHeight * -1}px`, '');
  }, []);

  return (
    <div className={styles.rollRoot}>
      <div className={styles.roll} ref={rollTextRef}>
        <div className={styles.section}>
          <p className={styles.heading2}>主催</p>
          <p className={styles.heading3}>福島県観光課</p>
        </div>
        <div className={styles.section}>
          <p className={styles.heading2}>企画・制作</p>
          <p className={styles.heading3}>株式会社タカラッシュ</p>
        </div>
        <div className={styles.section}>
          <p className={styles.heading2}>LINEアプリ開発</p>
          <p className={styles.heading3}>株式会社TAMSAN</p>
        </div>
      </div>
    </div>
  );
};
